/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

/* AUTH */
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const VALIDATE_EMAIL = 'VALIDATE EMAIL';
export const VALIDATE_EMAIL_SUCCESS = 'VALIDATE EMAIL SUCCESS';
export const VALIDATE_EMAIL_ERROR = 'VALIDATE EMAIL ERROR';

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = 'MENU_CHANGE_HAS_SUB_ITEM_STATUS';

/* EXTERNAL_REVIEW */
export const EXTERNAL_REVIEW_DETAIL = 'EXTERNAL_REVIEW_DETAIL';
export const EXTERNAL_REVIEW_DETAIL_SUCCESS = 'EXTERNAL_REVIEW_DETAIL_SUCCESS';
export const EXTERNAL_REVIEW_DETAIL_ERROR = 'EXTERNAL_REVIEW_DETAIL_ERROR';
export const EXTERNAL_REVIEW_ADD_SET= 'EXTERNAL_REVIEW_ADD_SET';
export const EXTERNAL_REVIEW_ADD_CHANGE= 'EXTERNAL_REVIEW_ADD_CHANGE';
export const EXTERNAL_REVIEW_EDIT_MODAL_SET= 'EXTERNAL_REVIEW_EDIT_MODAL_SET';
export const EXTERNAL_REVIEW_EDIT_TAB_SET= 'EXTERNAL_REVIEW_EDIT_TAB_SET';
export const EXTERNAL_REVIEW_SEARCH = 'EXTERNAL_REVIEW_SEARCH';
export const EXTERNAL_REVIEW_SEARCH_SUCCESS = 'EXTERNAL_REVIEW_SEARCH_SUCCESS';
export const EXTERNAL_REVIEW_SEARCH_ERROR = 'EXTERNAL_REVIEW_SEARCH_ERROR';
export const EXTERNAL_REVIEW_ADD = 'EXTERNAL_REVIEW_ADD';
export const EXTERNAL_REVIEW_ADD_SUCCESS = 'EXTERNAL_REVIEW_ADD_SUCCESS';
export const EXTERNAL_REVIEW_ADD_ERROR = 'EXTERNAL_REVIEW_ADD_ERROR';
export const EXTERNAL_REVIEW_ADD_MODAL_SET= 'EXTERNAL_REVIEW_ADD_MODAL_SET';
export const EXTERNAL_REVIEW_HEADER= 'EXTERNAL_REVIEW_HEADER';
export const EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST = 'EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST';
export const EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST_SUCCESS = 'EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST_SUCCESS';
export const EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST_ERROR = 'EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST_ERROR';
export const EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST = 'EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST';
export const EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST_SUCCESS = 'EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST_SUCCESS';
export const EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST_ERROR = 'EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST_ERROR';
export const EXTERNAL_REVIEW_LIST = 'EXTERNAL_REVIEW_LIST';
export const EXTERNAL_REVIEW_LIST_SUCCESS = 'EXTERNAL_REVIEW_LIST_SUCCESS';
export const EXTERNAL_REVIEW_LIST_ERROR = 'EXTERNAL_REVIEW_LIST_ERROR';
export const EXTERNAL_REVIEW_SEARCH_SET= 'EXTERNAL_REVIEW_SEARCH_SET';
export const EXTERNAL_REVIEW_SEARCH_CHANGE= 'EXTERNAL_REVIEW_SEARCH_CHANGE';
export const EXTERNAL_REVIEW_PAGE_SET= 'EXTERNAL_REVIEW_PAGE_SET';
export const EXTERNAL_REVIEW_VIEW_MODAL_SET= 'EXTERNAL_REVIEW_VIEW_MODAL_SET';
export const EXTERNAL_REVIEW_VIEW_DETAIL_MODAL_SET= 'EXTERNAL_REVIEW_VIEW_DETAIL_MODAL_SET';
export const EXTERNAL_REVIEW_VIEW_SET= 'EXTERNAL_REVIEW_VIEW_SET';
export const EXTERNAL_REVIEW_VIEW_TAB_SET= 'EXTERNAL_REVIEW_VIEW_TAB_SET';
export const EXTERNAL_REVIEW_EDIT_CHANGE = 'EXTERNAL_REVIEW_EDIT_CHANGE';
export const EXTERNAL_REVIEW_UPDATE = 'EXTERNAL_REVIEW_UPDATE';
export const EXTERNAL_REVIEW_UPDATE_SUCCESS = 'EXTERNAL_REVIEW_UPDATE_SUCCESS';
export const EXTERNAL_REVIEW_UPDATE_ERROR = 'EXTERNAL_REVIEW_UPDATE_ERROR';

/* UPLOAD FILE */
export const UPLOAD_SET = 'UPLOAD_SET';
export const UPLOAD_SET_SUCCESS = 'UPLOAD_SET_SUCCESS';
export const UPLOAD_SET_ERROR = 'UPLOAD_SET_ERROR';
export const UPLOAD_RESET = 'UPLOAD_RESET';

/* DASHBOARD */
export const DASHBOARD_LIST = 'DASHBOARD_LIST';
export const DASHBOARD_LIST_SUCCESS = 'DASHBOARD_LIST_SUCCESS';
export const DASHBOARD_LIST_ERROR = 'DASHBOARD_LIST_ERROR';
export const DASHBOARD_SEARCH_SET = 'DASHBOARD_SEARCH_SET';
export const DASHBOARD_SEARCH_CHANGE = 'DASHBOARD_SEARCH_CHANGE';
export const ARTICLE_CODE22 = 'ARTICLE_CODE22';
export const ARTICLE_CODE22_SUCCESS = 'ARTICLE_CODE22_SUCCESS';
export const ARTICLE_CODE22_ERROR = 'ARTICLE_CODE22_ERROR';
export const DASHBOARD_UNIT_PRICE = 'DASHBOARD_UNIT_PRICE';
export const DASHBOARD_UNIT_PRICE_SUCCESS = 'DASHBOARD_UNIT_PRICE_SUCCESS';
export const DASHBOARD_UNIT_PRICE_ERROR = 'DASHBOARD_UNIT_PRICE_ERROR';
export const DASHBOARD_SOURCE = 'DASHBOARD_SOURCE';
export const DASHBOARD_SOURCE_SUCCESS = 'DASHBOARD_SOURCE_SUCCESS';
export const DASHBOARD_SOURCE_ERROR = 'DASHBOARD_SOURCE_ERROR';
export const DASHBOARD_YEAR = 'DASHBOARD_YEAR';
export const DASHBOARD_YEAR_SUCCESS = 'DASHBOARD_YEAR_SUCCESS';
export const DASHBOARD_YEAR_ERROR = 'DASHBOARD_YEAR_ERROR';
export const DASHBOARD_PRICES = 'DASHBOARD_PRICES';
export const DASHBOARD_PRICES_SUCCESS = 'DASHBOARD_PRICES_SUCCESS';
export const DASHBOARD_PRICES_ERROR = 'DASHBOARD_PRICES_ERROR';
export const DASHBOARD_TRANSACTIONS = 'DASHBOARD_TRANSACTIONS';
export const DASHBOARD_TRANSACTIONS_SUCCESS = 'DASHBOARD_TRANSACTIONS_SUCCESS';
export const DASHBOARD_TRANSACTIONS_ERROR = 'DASHBOARD_TRANSACTIONS_ERROR';
export const DASHBOARD_RAZONABILIDAD = 'DASHBOARD_RAZONABILIDAD';
export const DASHBOARD_RAZONABILIDAD_SUCCESS = 'DASHBOARD_RAZONABILIDAD_SUCCESS';
export const DASHBOARD_RAZONABILIDAD_ERROR = 'DASHBOARD_RAZONABILIDAD_ERROR';
export const DASHBOARD_DATA_SUPPLIER = 'DASHBOARD_DATA_SUPPLIER';
export const DASHBOARD_DATA_SUPPLIER_SUCCESS = 'DASHBOARD_DATA_SUPPLIER_SUCCESS';
export const DASHBOARD_DATA_SUPPLIER_ERROR = 'DASHBOARD_DATA_SUPPLIER_ERROR';
export const DASHBOARD_DATA_SUPPLIER_PAGE_SET = 'DASHBOARD_DATA_SUPPLIER_PAGE_SET';

/*CATALOG LIST*/
export const ROUTE_ADMINISTRATION_GROUP = 'ROUTE_ADMINISTRATION_GROUP'
export const ROUTE_ADMINISTRATION_GROUP_SUCCESS = 'ROUTE_ADMINISTRATION_GROUP_SUCCESS';
export const ROUTE_ADMINISTRATION_GROUP_ERROR = 'ROUTE_ADMINISTRATION_GROUP_ERROR';
export const DOSAGE_FORM_GROUP = 'DOSAGE_FORM_GROUP';
export const DOSAGE_FORM_GROUP_SUCCESS = 'DOSAGE_FORM_GROUP_SUCCESS';
export const DOSAGE_FORM_GROUP_ERROR = 'DOSAGE_FORM_GROUP_ERROR';
export const ROUTE_ADMINISTRATION = 'ROUTE_ADMINISTRATION'
export const ROUTE_ADMINISTRATION_SUCCESS = 'ROUTE_ADMINISTRATION_SUCCESS';
export const ROUTE_ADMINISTRATION_ERROR = 'ROUTE_ADMINISTRATION_ERROR';
export const DOSAGE_FORM = 'DOSAGE_FORM';
export const DOSAGE_FORM_SUCCESS = 'DOSAGE_FORM_SUCCESS';
export const DOSAGE_FORM_ERROR = 'DOSAGE_FORM_ERROR';
export const DISPENSING_UNIT = 'DISPENSING_UNIT';
export const DISPENSING_UNIT_SUCCESS = 'DISPENSING_UNIT_SUCCESS';
export const DISPENSING_UNIT_ERROR = 'DISPENSING_UNIT_ERROR';
export const UNSPSC = 'UNSPSC';
export const UNSPSC_SUCCESS = 'UNSPSC_SUCCESS';
export const UNSPSC_ERROR = 'UNSPSC_ERROR';
export const UNSPSC_FAMILY = 'UNSPSC_FAMILY';
export const UNSPSC_FAMILY_SUCCESS = 'UNSPSC_FAMILY_SUCCESS';
export const UNSPSC_FAMILY_ERROR = 'UNSPSC_FAMILY_ERROR';
export const UNSPSC_CLASS = 'UNSPSC_CLASS';
export const UNSPSC_CLASS_SUCCESS = 'UNSPSC_CLASS_SUCCESS';
export const UNSPSC_CLASS_ERROR = 'UNSPSC_CLASS_ERROR';
export const DOSAGE_FORM_CODE20 = 'DOSAGE_FORM_CODE20';
export const DOSAGE_FORM_CODE20_SUCCESS = 'DOSAGE_FORM_CODE20_SUCCESS';
export const DOSAGE_FORM_CODE20_ERROR = 'DOSAGE_FORM_CODE20_ERROR';
export const ACTIVE_INGREDIENT_CODE20 = 'ACTIVE_INGREDIENT_CODE20';
export const ACTIVE_INGREDIENT_CODE20_SUCCESS = 'ACTIVE_INGREDIENT_CODE20_SUCCESS';
export const ACTIVE_INGREDIENT_CODE20_ERROR = 'ACTIVE_INGREDIENT_CODE20_ERROR';
export const MED_DESCRIPTION_CODE22 = 'MED_DESCRIPTION_CODE22';
export const MED_DESCRIPTION_CODE22_SUCCESS = 'MED_DESCRIPTION_CODE22_SUCCESS';
export const MED_DESCRIPTION_CODE22_ERROR = 'MED_DESCRIPTION_CODE22_ERROR';
export const SOURCE_CODE22 = 'SOURCE_CODE22';
export const SOURCE_CODE22_SUCCESS = 'SOURCE_CODE22_SUCCESS';
export const SOURCE_CODE22_ERROR = 'SOURCE_CODE22_ERROR';
export const ANIO_PRICE_CODE22 = 'ANIO_PRICE_CODE22';
export const ANIO_PRICE_CODE22_SUCCESS = 'ANIO_PRICE_CODE22_SUCCESS';
export const ANIO_PRICE_CODE22_ERROR = 'ANIO_PRICE_CODE22_ERROR';
export const UNIT_PRICE = 'UNIT_PRICE';
export const UNIT_PRICE_SUCCESS = 'UNIT_PRICE_SUCCESS';
export const UNIT_PRICE_ERROR = 'UNIT_PRICE_ERROR';
export const UNIT_PRICE_TRANSACCIONES = 'UNIT_PRICE_TRANSACCIONES';
export const UNIT_PRICE_TRANSACCIONES_SUCCESS = 'UNIT_PRICE_TRANSACCIONES_SUCCESS';
export const UNIT_PRICE_TRANSACCIONES_ERROR = 'UNIT_PRICE_TRANSACCIONES_ERROR';
export const BASKET = 'BASKET';
export const BASKET_SUCCESS = 'BASKET_SUCCESS';
export const BASKET_ERROR = 'BASKET_ERROR';

/*ORP PRICE*/
export const ORP_PRICE_SEARCH_SET = 'ORP_PRICE_SEARCH_SET';
export const ORP_PRICE_SEARCH_CHANGE = 'ORP_PRICE_SEARCH_CHANGE';
export const ORP_PRICE_GRAPH = 'ORP_PRICE_GRAPH';
export const ORP_PRICE_GRAPH_SUCCESS = 'ORP_PRICE_GRAPH_SUCCESS';
export const ORP_PRICE_GRAPH_ERROR = 'ORP_PRICE_GRAPH_ERROR';
export const ORP_COMPRAS_UNOPS = 'ORP_COMPRAS_UNOPS';
export const ORP_COMPRAS_UNOPS_SUCCESS = 'ORP_COMPRAS_UNOPS_SUCCESS';
export const ORP_COMPRAS_UNOPS_ERROR = 'ORP_COMPRAS_UNOPS_ERROR';
export const ORP_COMPRAS_UNOPS_SET = 'ORP_COMPRAS_UNOPS_SET';
export const ORP_COMPRAS_UNOPS_PAGE_SET = 'ORP_COMPRAS_UNOPS_PAGE_SET';
export const ORP_COMPRAS_UNOPS_SEARCH_CHANGE = 'ORP_COMPRAS_UNOPS_SEARCH_CHANGE';

/*BASKET MEDICINE*/
export const BASKET_MEDICINE = 'BASKET_MEDICINE'; 
export const BASKET_MEDICINE_SUCCESS = 'BASKET_MEDICINE_SUCCESS';
export const BASKET_MEDICINE_ERROR = 'BASKET_MEDICINE_ERROR';
export const BASKET_MEDICINE_SEARCH_SET = 'BASKET_MEDICINE_SEARCH_SET';
export const BASKET_MEDICINE_SEARCH_CHANGE = 'BASKET_MEDICINE_SEARCH_CHANGE';

/*MENU ROLE*/
export const MENU_ROLE = 'MENU_ROLE';
export const MENU_ROLE_SUCCESS = 'MENU_ROLE_SUCCESS';
export const MENU_ROLE_ERROR = 'MENU_ROLE_ERROR';

/*ARTICLE CARD*/
export const ARTICLE = 'ARTICLE';
export const ARTICLE_SUCCESS = 'ARTICLE_SUCCESS';
export const ARTICLE_ERROR = 'ARTICLE_ERROR';
export const ARTICLE_CARD_INFO = 'ARTICLE_CARD_INFO';
export const ARTICLE_CARD_INFO_SUCCESS = 'ARTICLE_CARD_INFO_SUCCESS';
export const ARTICLE_CARD_INFO_ERROR = 'ARTICLE_CARD_INFO_ERROR';
export const ARTICLE_CARD_SEARCH_SET = 'ARTICLE_CARD_SEARCH_SET';
export const ARTICLE_CARD_SEARCH_CHANGE = 'ARTICLE_CARD_SEARCH_CHANGE';
export const ARTICLE_CARD_TAB_SET = 'ARTICLE_CARD_TAB_SET';

export * from './menu/actions';
export * from './settings/actions';
export * from './auth/actions';
export * from './external_review/actions';
export * from './upload/actions';
export * from './dashboard/actions';
export * from './catalogList/actions';
export * from './orp/actions';
export * from './orpcompras/actions';
export * from './validate_email/actions';
export * from './basket_medicine/actions';
export * from './menuRole/actions';
export * from './article_card/actions';